"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var execCommand_1 = require("../utils/execCommand");
/**
 * Set content alignment
 * @param editor The editor instance
 * @param alignment The alignment option:
 * Alignment.Center, Alignment.Left, Alignment.Right
 */
function setAlignment(editor, alignment) {
    var command = "justifyLeft" /* JustifyLeft */;
    var align = 'left';
    if (alignment == 1 /* Center */) {
        command = "justifyCenter" /* JustifyCenter */;
        align = 'center';
    }
    else if (alignment == 2 /* Right */) {
        command = "justifyRight" /* JustifyRight */;
        align = 'right';
    }
    editor.addUndoSnapshot(function () {
        execCommand_1.default(editor, command);
        editor.queryElements('[align]', 1 /* OnSelection */, function (node) { return (node.style.textAlign = align); });
    }, "Format" /* Format */);
}
exports.default = setAlignment;
//# sourceMappingURL=setAlignment.js.map